// src/utils/variants.js
export function variantKeyOf(v = {}) {
  // clé stable pour le panier (ex: "color:Red|size:42|typeId:1|detailId:3")
  const parts = [];
  if (v.color != null) parts.push(`color:${v.color}`);
  if (v.size != null) parts.push(`size:${v.size}`);
  if (v.typeId != null) parts.push(`typeId:${v.typeId}`);
  if (v.detailId != null) parts.push(`detailId:${v.detailId}`);
  return parts.join("|") || "default";
}

export function variantLabel(v = {}) {
  return [v.color, v.size].filter(Boolean).join(" / ") || "Standard";
}

export function groupVariantOptions(variants = []) {
  // extrait la liste des valeurs possibles par attribut
  const colors = [...new Set(variants.map(v => v.color).filter(Boolean))];
  const sizes  = [...new Set(variants.map(v => v.size).filter(Boolean))];
  return { colors, sizes };
}

export function findVariant(variants = [], { color, size }) {
  return variants.find(v =>
    (color ? v.color === color : true) &&
    (size ? v.size === size : true)
  ) || null;
}
